import React, { useEffect, useMemo, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import NationalVendorList from '../../main/containers/national-vendor-list'
import { isNationalCatalogService, Service } from '../../models'
import { useService, useUser } from '../../hooks'
import { Routes } from '../../navigation/config/routes'

export const NVLListPage = () => {
    const history = useHistory()
    const location = useLocation()
    const { workspaceUser } = useUser()
    const { serviceList } = useService({ getServiceList: true, cleanUp: true })
    const nationalServiceList = useMemo(
        () => serviceList.filter(isNationalCatalogService),
        [serviceList],
    )

    const params = new URLSearchParams(location.search)
    const serviceIdParam = params.get('serviceId')
    const vendorQuery = params.get('q') ?? ''
    const vendorIdParam = params.get('vendorId')
    const vendorIdFromUrl =
        vendorIdParam && Number(vendorIdParam) > 0
            ? Number(vendorIdParam)
            : undefined

    const serviceFromUrl = serviceIdParam
        ? nationalServiceList.find(
              (service) => service.id === Number(serviceIdParam),
          )
        : undefined

    const [selectedService, setSelectedService] = useState<
        Service | undefined
    >()

    useEffect(() => {
        setSelectedService(serviceFromUrl)
    }, [serviceFromUrl?.id, serviceIdParam])

    const defaultLocation = workspaceUser?.active_workspace
        ? `${workspaceUser.active_workspace.address} ${workspaceUser.active_workspace.city}, ${workspaceUser.active_workspace.state}`
        : ''

    return (
        <NationalVendorList
            location={defaultLocation}
            selectedService={selectedService}
            setSelectedService={setSelectedService}
            initialVendorSearch={vendorIdFromUrl ? '' : vendorQuery}
            initialVendorId={vendorIdFromUrl}
            onBack={() => history.push(Routes.public.nvl.root)}
        />
    )
}
